//import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { Tab } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import secureStorage from "@src/config/encrypt";
import { toast } from 'react-toastify';
import FullPageLoader from '@src/common/FullPageLoader';
import { useLanguage } from "@src/context/LanguageContext";
import { getDashboardCount } from '@src/store/slices/lead';

// const InsurancePaymentIcon = require('../styles/webroot/images/insurance-payment.svg');


const Dashboard: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const {translations} = useLanguage();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    // const [redirect, setRedirect] = useState(false);
    // const [role, setRole] = useState("");
    let [searchValue, setSearchValue] = useState<string>()
    const [dashboardCount, setDashboardCount] = useState<any>({});
    

    useEffect(() => {
        let result = secureStorage.getItem("authUserInfo");
        if (!result) {
            // setRedirect(true)
        } else {
            let userInfo = result.user_data;
            setName((userInfo && userInfo.name) || '');
            // setRole(userInfo && userInfo.role_title);
            getDashboardList();

        }
    }, []);

    const getDashboardList = () => {
        setLoading(true)
        getDashboardCount().then((res: any) => {
            setLoading(false)
            if (res && res.status === 200) {
                setDashboardCount({...res.data});
            }
        }).catch(err => setLoading(false))
    }

    const setNewState = () => {
        //     dispatch(userNameSet("Insurance Box"))
    }

    const searchClickHandler = () => {
        if (searchValue) {
            if (searchValue.length <= 10) {
                navigate({
                    pathname: '/lead-list',
                    search: `?searchKeyword=${searchValue}`,
                });
            } else {
                toast.error(translations.Dashboard?.['SEARCH_ERROR_LENGTH_MSG'] || translations.commonMsg?.loading);
            }
        } else {
            toast.error(translations.Dashboard?.['SEARCH_ERROR_MSG'] || translations.commonMsg?.loading);
        }
    }

     const onChangeHandler = (value: string) => {
        setSearchValue("");
        let pattern = /^[0-9]*$/;

        if (value.trim() && pattern.test(value)) {
            setSearchValue(value);
        }
    }

    const countClickHandler = (status: any, count: any, filterType: any="") => {
        if (count !== 0) {
            navigate({
                pathname: '/lead-list',
                //search: `?status_id_arr=${status}&sub_status_id_arr=${substatus}${filterType? `&filterType=${filterType}` : '' }`,
                search: `?status=${status}${filterType? `&filterType=${filterType}` : '' }`,
            });
        }
    }

    const handleEnter = (e:any) => {
        if (e.key === "Enter") {
            searchClickHandler();
        }
    };
   
    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="dashboard-bg">
                <div className="dashboard-outer">
                    <div className="heading">
                        <span className="subheading">{translations.Dashboard?.['HELLO'] || translations.commonMsg?.loading} {name}</span>

                        <h1 onClick={setNewState}>{translations.Dashboard?.['WELCOME_TO_INSURANCE_MEGA_BOX'] || translations.commonMsg?.loading}</h1>
                    </div>
                    <div className="search-bx">
                        <input name="search" value={searchValue} onChange={(e: any) => onChangeHandler(e.target.value)} type="text" placeholder={translations.Dashboard?.['SEARCH_BY_INSURANCE_ID_OR_MOBILE'] || translations.commonMsg?.loading} maxLength={10}  onKeyDown={handleEnter} />
                        <button className="search-btn" onClick={searchClickHandler}>{translations.Dashboard?.['SEARCH'] || translations.commonMsg?.loading}</button>
                        <i className="ic-search"></i>
                    </div>
                    <div className="dashboard-toggle-tab">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <div className="dashboard-card">
                                        
                                        <div className="card color-one" onClick={() => countClickHandler(dashboardCount?.all_count?.status, dashboardCount?.all_count?.count, "all_count")}>
                                            <div className="roung-bg">
                                                <i className="ic-pending-application">
                                                    <i className="path1"></i>
                                                    <i className="path2"></i>
                                                    <i className="path3"></i>
                                                    <i className="path4"></i>
                                                    <i className="path5"></i>
                                                    <i className="path6"></i>
                                                    <i className="path7"></i>
                                                    <i className="path8"></i>
                                                    <i className="path9"></i>
                                                    <i className="path10"></i>
                                                </i>
                                            </div>
                                            {/* <span className="count-txt" onClick={() => countClickHandler(dashboardCount?.pending_app?.status, dashboardCount?.pending_app?.substatus, dashboardCount?.pending_app?.count, "pending")}>{dashboardCount?.pending_app?.count}</span>
                                            <span className="card-txt">{dashboardCount?.pending_app?.name}</span> */}
                                                <span className="count-txt"> {dashboardCount?.all_count?.count} </span>
                                                <span className="card-txt">{translations.Dashboard?.['ALL_APPLICATION'] || translations.commonMsg?.loading}  </span>
                                        </div>
                                    
                                        <div className="card color-two" onClick={() => countClickHandler(dashboardCount?.in_process?.status, dashboardCount?.in_process?.count, "in_process")}>
                                            <div className="roung-bg">
                                                <i className="ic-application"></i>
                                            </div>
                                                <span className="count-txt" > {dashboardCount?.in_process?.count} </span>
                                                <span className="card-txt"> {translations.Dashboard?.['IN_PROGRESS'] || translations.commonMsg?.loading} </span>
                                           
                                        </div>
            
                                        <div className="card color-three" onClick={() => countClickHandler(dashboardCount?.action_needed_by_oto?.status, dashboardCount?.action_needed_by_oto?.count, "action_needed_by_oto")}>
                                            <div className="roung-bg">
                                                <i className="ic-financier">
                                                    <i className="path1"></i>
                                                    <i className="path2"></i>
                                                    <i className="path3"></i>
                                                    <i className="path4"></i>
                                                    <i className="path5"></i>
                                                    <i className="path6"></i>
                                                    <i className="path7"></i>
                                                    <i className="path8"></i>
                                                    <i className="path9"></i>
                                                    <i className="path10"></i>
                                                </i>
                                            </div>
                                            {/* <span className="count-txt ">{dashboardCount?.ins_broker?.count}</span>
                                            <span className="card-txt">{translations.Dashboard?.['ins_broker'] || dashboardCount?.ins_broker?.name}</span> */}
                                                <span className="count-txt" > {dashboardCount?.action_needed_by_oto?.count} </span>
                                                <span className="card-txt">{translations.Dashboard?.['ACTION_NEEDED'] || translations.commonMsg?.loading}   </span>
                                                
                                        </div>
                                    
                                        <div className="card color-four" onClick={() => countClickHandler(dashboardCount?.re_submitted_for_review?.status, dashboardCount?.re_submitted_for_review?.count, "re_submitted_for_review")}>
                                            <div className="roung-bg">
                                                <i className="ic-softapproved">
                                                    <i className="path1"></i>
                                                    <i className="path2"></i>
                                                    <i className="path3"></i>
                                                    <i className="path4"></i>
                                                    <i className="path5"></i>
                                                    <i className="path6"></i>
                                                    <i className="path7"></i>
                                                    <i className="path8"></i>
                                                </i>
                                            </div>
                                            {/* <span className="count-txt " onClick={() => countClickHandler(dashboardCount?.soft_approval?.status, dashboardCount?.soft_approval?.substatus, dashboardCount?.soft_approval?.count)}>{dashboardCount?.soft_approval?.count}</span>
                                            <span className="card-txt">{dashboardCount?.soft_approval?.name}</span> */}
                                                <span className="count-txt"> {dashboardCount?.re_submitted_for_review?.count} </span>
                                               <span className="card-txt">{translations.Dashboard?.['RE_SUBMITTED'] || translations.commonMsg?.loading} </span>
                                        </div>
                                    
                                        <div className="card color-five" onClick={() => countClickHandler(dashboardCount?.policy_issued?.status, dashboardCount?.policy_issued?.count, "policy_issued")}>
                                            <div className="roung-bg">
                                                <i className="ic-softapproved">
                                                    <i className="path1"></i>
                                                    <i className="path2"></i>
                                                    <i className="path3"></i>
                                                    <i className="path4"></i>
                                                    <i className="path5"></i>
                                                    <i className="path6"></i>
                                                    <i className="path7"></i>
                                                    <i className="path8"></i>
                                                </i>
                                            </div>
                                            {/* <span className="count-txt ">{dashboardCount?.ins_policy?.count}</span>
                                            <span className="card-txt">{translations.Dashboard?.['ins_policy'] || dashboardCount?.ins_policy?.name}</span> */}
                                                <span className="count-txt"> {dashboardCount?.policy_issued?.count} </span>
                                                <span className="card-txt">{translations.Dashboard?.['POLICY_ISSUED'] || translations.commonMsg?.loading}   </span>
                                        </div>
                                    
                                        <div className="card color-six" onClick={() => countClickHandler(dashboardCount?.rejected?.status, dashboardCount?.rejected?.count, "rejected")}>
                                            <div className="roung-bg">
                                                <i className="ic-softapproved">
                                                    <i className="path1"></i>
                                                    <i className="path2"></i>
                                                    <i className="path3"></i>
                                                    <i className="path4"></i>
                                                    <i className="path5"></i>
                                                    <i className="path6"></i>
                                                    <i className="path7"></i>
                                                    <i className="path8"></i>
                                                </i>
                                            </div>
                                            {/* <span className="count-txt ">{dashboardCount?.incentive_payment?.count}</span>
                                            <span className="card-txt">{dashboardCount?.incentive_payment?.name}</span> */}
                                                <span className="count-txt"> {dashboardCount?.rejected?.count} </span>
                                                <span className="card-txt">{translations.Dashboard?.['REJECTED'] || translations.commonMsg?.loading}  </span>
                                        </div>

                                            <div className="card color-six" onClick={() => countClickHandler(dashboardCount?.lost?.status, dashboardCount?.lost?.count, "lost")}>
                                            <div className="roung-bg">
                                                <i className="ic-softapproved">
                                                    <i className="path1"></i>
                                                    <i className="path2"></i>
                                                    <i className="path3"></i>
                                                    <i className="path4"></i>
                                                    <i className="path5"></i>
                                                    <i className="path6"></i>
                                                    <i className="path7"></i>
                                                    <i className="path8"></i>
                                                </i>
                                            </div>
                                            {/* <span className="count-txt ">{dashboardCount?.incentive_payment?.count}</span>
                                            <span className="card-txt">{dashboardCount?.incentive_payment?.name}</span> */}
                                                <span className="count-txt"> {dashboardCount?.lost?.count} </span>
                                                <span className="card-txt">{translations.Dashboard?.['LOST_LEADS'] || translations.commonMsg?.loading} </span>
                                        </div>

                                    </div>
                                </Tab.Pane>

                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default Dashboard